// Following 'unity-product-svc'.
export enum AgentType {
  Default = 0,
  AgentDirect = 1,
  AgentIndirect = 2,
  Banca = 3,
  BancaNonStaff = 4,
}

export enum AgentTypeId {
  Default = 0,
  Agent = 1,
  Banca = 2,
  Direct = 3,
  Indirect = 4,
}

export enum AgentTypeName {
  Default = 'Default',
  Agent = 'Agent',
  Banca = 'Banca',
  Direct = 'Direct',
  Indirect = 'Indirect',
}

export enum AgentCode {
  UatBkrmTakaful = 'N0028409',
  ProdBkrmTakaful = 'N0028409',
  UatBKRM2Takaful = 'N0041618',
  ProdBKRM2Takaful = 'N0041618',
}
